module.exports = __webpack_public_path__ + "assets/8c24fcee0426f414f7c4d0f952e3e07c.mp3";